import { GAME_STATES } from '../../constants';

const MobileViewSwitcher = ({ activeTab, onTabChange, gameState }) => {
    const isBombPhase = gameState === GAME_STATES.placing_bombs;

    return (
        <div className="mobile-view-switcher">
            <button
                className={`mvs-tab${activeTab === 'board' ? ' mvs-tab--active' : ''}`}
                onClick={() => onTabChange('board')}
            >
                <span className="mvs-icon">♟</span>
                <span className="mvs-label">Board</span>
            </button>
            <button
                className={`mvs-tab${activeTab === 'moves' ? ' mvs-tab--active' : ''}${isBombPhase ? ' mvs-tab--amber' : ''}`}
                onClick={() => onTabChange('moves')}
            >
                <span className="mvs-icon">{isBombPhase ? '💣' : '📋'}</span>
                <span className="mvs-label">{isBombPhase ? 'Bombs' : 'Moves'}</span>
            </button>
            <button
                className={`mvs-tab${activeTab === 'settings' ? ' mvs-tab--active' : ''}`}
                onClick={() => onTabChange('settings')}
            >
                <span className="mvs-icon">⚙</span>
                <span className="mvs-label">Settings</span>
            </button>
        </div>
    );
};

export default MobileViewSwitcher;
